import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext({});

export const NavigationProvider = ({ children }) => {
    const [currentPage, setCurrentPage] = useState('historico');
    const navigate = useNavigate();

    const navigateTo = (page, skipNavigation = false) => {
        setCurrentPage(page);
        
        if (skipNavigation) {
            return;
        }
        
        switch (page) {
            case 'flows':
            case 'flows-new':
                navigate('/flows-new');
                break;
            case 'historico':
                navigate('/history');
                break;
            case 'relatorios':
                navigate('/reports');
                break;
            case 'usuarios':
                navigate('/users');
                break;
            case 'configuracoes':
                navigate('/settings');
                break;
            case 'perfil':
                navigate('/profile');
                break;
            case 'global-variable-mappings':
                navigate('/global-variable-mappings');
                break;
            case 'question-bank':
                navigate('/question-bank');
                break;
            case 'nova-analise':
                navigate('/');
                break;
            default:
                navigate('/');
        }
    };

    return (
        <NavigationContext.Provider value={{ currentPage, navigateTo }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigation = () => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}; 